// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"610":"cacf15aa","633":"a02b8cd7","892":"b288322b","940":"ac411a67"}[chunkId] + ".chunk.css";
};